import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import '../../../../Assets/EnsembleStyles/EnsLogin.css';
import { SingleSignOnAction, UpdateLogonTransaction, UpdateOnPremiseState, ResetOnPrimiseError, UpdateEquipmentSummaryState, GetBacnetBuildingId, faciltySingleSignOnAction } from '../../../../action/authenticateUser';
import { identityCall  } from 'amplitude/amplitude';
import { getServerType } from '../../../../action/Administration/license';
import { GetUserDetails, GetApplicationVersion } from '../../../../action/Administration/administrationAction';
import { GetInvoiceLogo } from "../../../../action/invoiceAction";


class SingleSignOn extends Component {
  
    componentWillMount(){
      var OnPremiseState;
      this.props.getServerType("FM");
       this.props.getApplicationVersion();
      var tenantSessionId = localStorage.getItem("tenantSessionId");
      var window_URL=  window.top.location.href;
      var myurls = window_URL.split("?token=");
    // retrieve query params from the url ~/React/#/sso?home=FacilityManagement&tenantId=2
      var user_id = window_URL.split("&tenantId=");
      var tenantUserId = user_id[1] || localStorage.getItem('TenantUserID');
      
      var trane_token = myurls[1]; 
      var HomeUrl = window_URL.split("?home=");

      if(tenantUserId !== null && tenantUserId !== undefined && tenantUserId !== "") {
      this.props.getUserDetails(tenantUserId);
      }

    
      if(trane_token === undefined && tenantSessionId !== undefined && tenantSessionId !== null)
      {
        trane_token = tenantSessionId;
        OnPremiseState = true;
        localStorage.setItem("isOnPremise", true);
        this.setState({IsTenantHome : HomeUrl[1]});
        var MailDetails = localStorage.getItem('mailWorkOrderId');
        if (MailDetails === undefined || MailDetails === null || MailDetails === "null" || MailDetails === "") {
            if(window_URL.indexOf("&WorkOrderId=") > -1)
            {
                var MailUrl = window_URL.split("&WorkOrderId=");
                localStorage.setItem("mailWorkOrderId", MailUrl[1]);
            }
        }
        var PMMailDetails = localStorage.getItem('mailPMId');
        if (PMMailDetails === undefined || PMMailDetails === null || PMMailDetails === "null" || PMMailDetails === "") {
            if(window_URL.indexOf("&PMId=") > -1)
            {
                var PMMailUrl = window_URL.split("&PMId=");
                localStorage.setItem("mailPMId", PMMailUrl[1]);
            }
        }
      }     
      else
      {
        localStorage.setItem("isOnPremise", false);
        OnPremiseState = false;
      }      
      
      var actionResponse ;

      if(HomeUrl[1] === 'FacilityManagement'){
        this.props.GetInvoiceLogo();
        localStorage.setItem("facility_page_to_display",null );
        actionResponse =this.props.faciltySingleSignOnAction(trane_token) 
      }else{
        actionResponse =this.props.SingleSignOnAction(trane_token)
      }
      actionResponse.then((result) => {
            this.setState({HasTokenGenerated:true});
      })

      let Data = [];
      var l_BuildingId = window.location.pathname.endsWith("Summary.aspx") || window.location.pathname.endsWith("SummaryGroup.aspx") ? window.top.location.href.split("BuildingId=")[1].split("&")[0] : 0;
      var l_EquipmentId = window.location.pathname.endsWith("Summary.aspx") || window.location.pathname.endsWith("SummaryGroup.aspx") ? window.top.location.href.split("EquipmentId=")[1].split("#")[0] : 0;

      if(l_BuildingId > 0)
      {
      const actionResponse1 = this.props.GetBacnetBuildingId(l_BuildingId);
      actionResponse1.then((result) => {
        var lineitem = {
            "BuildingID": result,
            "EquipmentID": l_EquipmentId
          }
    
          Data.push(lineitem);
          this.props.UpdateEquipmentSummaryState(Data);
      })
      }
      else
      {
        var lineitem = {
            "BuildingID": l_BuildingId,
            "EquipmentID": l_EquipmentId
          }
    
          Data.push(lineitem);
          this.props.UpdateEquipmentSummaryState(Data);  
      }
      
      this.props.UpdateOnPremiseState(OnPremiseState);
    }


    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            if(nextProps.login_response.loggedIn === true){
                // if(nextProps.login_response.token !==null && nextProps.login_response.user_type ==="property_manager"){
                    
                //     var logondetails = {
                //         "LogOnTransaction": true,
                //         "LogOffType":null,
                //         "LogOnTransactionId":null
                //     }
                    
                //     this.props.UpdateLogonTransaction(logondetails);
                // }
                this.setState({ 
                    loggedIn: nextProps.login_response.loggedIn,
                     token: nextProps.login_response.token,
                     user_type: nextProps.login_response.user_type, 
                     error_msg: false, 
                     redirect_to_tenant:true,
                     version: nextProps.version,
                     user_role: nextProps.userDetails.role
                  });
            }

            if(nextProps.login_response.API_not_responding)
            {
                this.props.ResetOnPrimiseError();
            }
               
             if(nextProps.login_response.loggedIn === false && !nextProps.login_response.API_not_responding){
                this.setState({ 
                    redirect_to_login:true,
                    login_url_fail_sso:nextProps.login_response.singleSignOn_login_url
                  });
             }
        }
    }


    constructor(props) {
        super(props);
        this.state = {
            error_msg:false,
            redirect_to_login:false,
            redirect_to_tenant:false,
            token:null,
            loggedIn:null,
            user_type:null,
            login_url_fail_sso:null,
            HasTokenGenerated: false,
            IsTenantHome: "tenant",
            version:'',
            user_role:'Administrator'
        }

        this.setAmplitude = this.setAmplitude.bind(this);
    }

    setAmplitude(){
        var eventProperties ={
            "userID":localStorage.getItem("TenantUserID"),
            "userRole":this.state.user_role,
            "client":"Tracer Ensemble",
            "version":this.state.version,
        }
        identityCall(eventProperties);
    }


    render() {     
        let {token, loggedIn, user_type,redirect_to_login,login_url_fail_sso} = this.state;
        var window_URL=  window.top.location.href;

        if(token !==null && loggedIn ===true && this.state.HasTokenGenerated){
            this.setAmplitude();

            if(user_type ==="property_manager")
            {
                if(this.state.IsTenantHome !== undefined)
                {
                if(this.state.IsTenantHome === "tenant")
                {
                    return <Redirect to ={"/managetenant"} />
                }
                if(this.state.IsTenantHome === "ManageReports")
                {
                    return <Redirect to ={"/ManageReports/ManageReportsDefinitions"} />
                }
                if(this.state.IsTenantHome === "ASUInvoice")
                {
                    return <Redirect to={"/ManageASU"} />
                }
                if(this.state.IsTenantHome === "ManagePreventativeMaintenance" || this.state.IsTenantHome.indexOf("ManagePreventativeMaintenance&PMId=") >= 0)
                {
                    return <Redirect to={"/ManageWorkOrder"} />
                }
                if(this.state.IsTenantHome === "workOrder" || this.state.IsTenantHome.indexOf("workOrder&WorkOrderId=") >= 0)
                {
                    return <Redirect to={"/ManageWorkOrder"} />
                }
                if(this.state.IsTenantHome === "ManageSiteLicense"){
                    return <Redirect to={"/ManageSiteLicense"} />
                }
                if(this.state.IsTenantHome.indexOf("EventMarker") >= 0)
                {
                    //this will set and remove  building id if not present in the url being passed in
                    var redirectUrl = "/ManageReports/EventMarker";

                    if(window_URL.indexOf("&BuildingId=") > -1)
                    {
                        var BuildingId = window_URL.split("&BuildingId=");
                        sessionStorage.setItem("buildingId", BuildingId[1]);
                        redirectUrl = `/ManageReports/EventMarker?BuildingId=${BuildingId[1]}`
                    } else {
                        sessionStorage.removeItem("buildingId"); 
                    }

                    return <Redirect to={redirectUrl} />
                }

                if(this.state.IsTenantHome === "InvalidLoginLog"){
                    return <Redirect to={"/SystemAdmin/InvalidLoginLog"} />
                }

                if(this.state.IsTenantHome === "Dashboard")
                {
                    return <Redirect to={"/ManageReports/Dashboard"} />
                }                
                
                if(this.state.IsTenantHome === "Dashboard2")
                {
                    return <Redirect to={"/ManageReports/Dashboard2"} />
                }

                if(this.state.IsTenantHome === "BACNet")
                {
                    return <Redirect to={"/ManageBacnet"} />
                }

                if(this.state.IsTenantHome === "ViewHubParameters")
                {
                    return <Redirect to={"/ViewHubParameters"} />
                }

                if(this.state.IsTenantHome === "SignCertificate")
                {
                    return <Redirect to={"/ManageSignCertificate"} />
                }

                if(this.state.IsTenantHome && this.state.IsTenantHome.startsWith("EquipmentList"))
                {
                    return <Redirect to={`/${this.state.IsTenantHome}`} />
                }

                if (this.state.IsTenantHome === "Datalogs") {
                    return <Redirect to={"/Datalogs"} />
                }

                if(this.state.IsTenantHome === "/SupportFilesList")
                {
                    return <Redirect to={"/ManageSupportFiles"} />
                }
                else {
                    return <Redirect to={"/UserNotAuthorized"} />
                }
            }
            else
            {
                if(window.location.pathname.endsWith("Summary.aspx") || window.location.pathname.endsWith("SummaryGroup.aspx"))
                {
                    return <Redirect to={"/EquipmentWrapper"} />
                }
                else if(window.location.pathname.endsWith("TESAlarms.aspx") || window.location.pathname.endsWith("BuildingAlarms.aspx"))
                {
                    return <Redirect to={"/AlarmWrapper"} />
                }
                else {
                    return <Redirect to={"/UserNotAuthorized"} />
                }
            }
                    
            }
            else if(user_type ==="tenant_employee")
            {
                var tenantUserId = localStorage.getItem('TenantUserID');       
                return <Redirect to={{ pathname: '/FacilityManagement/home', state: {tenantUserId:tenantUserId}}}/>
            }
        }

        else if( redirect_to_login ===true && login_url_fail_sso !==null  ){
            window.location.href = login_url_fail_sso;
        }
        
        return (
            <div> </div> 
        );
    }
}

const mapStateToProps = state => {
    return {
      login_response: state.authService,
      userDetails: state.InstallationsRootReducer.UserDeatils,
      version: state.InstallationsRootReducer.ApplicationVersion
    };
  };

const mapDispatchToProps = dispatch => {
    return {
        faciltySingleSignOnAction: (tenantSessionId) => dispatch(faciltySingleSignOnAction(tenantSessionId)),
        SingleSignOnAction: (trane_connect_token) => dispatch(SingleSignOnAction(trane_connect_token)),
        UpdateLogonTransaction: (logondetails) => dispatch(UpdateLogonTransaction(logondetails)),
        UpdateOnPremiseState: (OnPremiseState) => dispatch(UpdateOnPremiseState(OnPremiseState)),
        UpdateEquipmentSummaryState: (Data) => dispatch(UpdateEquipmentSummaryState(Data)),
        ResetOnPrimiseError: () => dispatch(ResetOnPrimiseError()),
        GetBacnetBuildingId: (Id) => dispatch(GetBacnetBuildingId(Id)),
        getServerType: (featureName) => dispatch(getServerType(featureName)),
        getUserDetails: (userID) => dispatch(GetUserDetails(userID)), 
        getApplicationVersion: () => dispatch(GetApplicationVersion()),
        GetInvoiceLogo: () => dispatch(GetInvoiceLogo()),

    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(SingleSignOn);